
export default function CommunitySection({ data }: any) {
  return (
    <>
      <section className="features__area-two section-pt-120 section-pb-90 area">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-6 col-lg-8">
              <div className="section__title text-center mb-40">
                <span className="sub-title">
                  {data?.highlightCommunityTexts}
                </span>
                <h2 className="title">{data?.communityTitle}</h2>
                <p>{data?.communityDescription}</p>
              </div>
            </div>
          </div>
          <div className="features__item-wrap">
            <div className="row justify-content-center">
              {data?.communityTabs?.map((tab: any, index: number) => (
                <div className="col-lg-4 col-md-6" key={index}>
                  <div className="features__item-two">
                    <div className="features__content-two">
                      <div className="content-top">
                        <div className="features__icon-two">
                          <img
                            src={
                              tab?.communityIcon?.node?.sourceUrl
                            }
                            alt="community-icon"
                            width="35px"
                          />
                        </div>
                        <h2 className="title">{tab?.communityTitle}</h2>
                      </div>
                      <p style={{ textTransform: "none" }}>
                        {tab?.communityDescription}
                      </p>
                    </div>
                    <div className="features__item-shape">
                      <img
                        src={"/assets/img/others/features_item_shape.svg"}
                        width={49}
                        height={37}
                        alt="img-text"
                        className="injectable"
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
